export const mapOrderDetailsToDpState = (data) => {
  const shipToPartyCarts = {};
  data.shipment_details.forEach((shipment) => {
    const stpInfo = shipment.ship_to_party_info;
    const products = shipment.product_summary_info
    const company = stpInfo.company_info;
    const address_info = stpInfo.address_info;
    const shipToPartyId = company.id;


    const cart = products.map((p) => ({
      order_product_delivery_id: p?.order_product_delivery_id,
      product_id: p.product_id,
      product_name: p.name,
      product_image: p.product_logo,
      current_price_per_unit: p.price_info.price_per_unit_ex_gst,
      quantity: {
        quantity_in_metric_ton: p.ordered.quantity_in_metric_ton,
        quantity_in_bags: p.ordered.quantity_in_bags,
        multiplier: p.ordered.multiplier,
        unit: p.ordered.unit,
        base_unit: p.ordered.base_unit
      },
      form_type: p.form_type,
      description: p.description,
      shipToPartyId,
      isExistingItem: true,
    }));

    const totals = {
      total_quantity_in_metric_ton: cart.reduce(
        (sum, i) => sum + i.quantity.quantity_in_metric_ton,
        0
      ),
      total_cart_value: cart.reduce(
        (sum, i) =>
          sum +
          i.quantity.quantity_in_metric_ton * i.current_price_per_unit,
        0
      )
    };

    shipToPartyCarts[shipToPartyId] = {
      cart,
      totals,
      invoice_info: shipment.invoice_info ?? [],
      ship_to_party_summary: {
        so_id: shipment.ship_to_party_summary?.so_id ?? null,
        ship_to_party_name: shipment.ship_to_party_summary?.ship_to_party_name ?? company?.name,
        quantity_info: shipment.ship_to_party_summary?.quantity_info ?? [],
      },
      shipToPartyDetails: {
        humbee_so_id : stpInfo.humbee_so_id,
        company_id: company?.id,
        company_name: company?.name,
        company_phone_no: company?.phone,
        company_registered_address: company.company_registered_address,
        pricing_geography_id: stpInfo?.pricing_geography_info?.pricing_geography_id,
        pricing_geography_name: stpInfo?.pricing_geography_info?.pricing_geography_name,
        gstin: company.gstin,
        selected_esi_info: {
          esi_id: company.esi_id,
          external_system_code: company.external_system_code
        },
        selected_esi_id: company.esi_id,
        selectedRole: company.company_role,
        delivery_Address_line1: address_info?.address.address_line_1,
        delivery_Address_line2: address_info?.address.address_line_2,
        delivery_Address_line3: address_info?.address.address_line_3,
        delivery_company_pincode: address_info?.pincode,
        delivery_district_id: address_info?.district_info.id,
        delivery_district_name: address_info?.district_info.name,
        delivery_state_id: address_info?.state_info.id,
        delivery_state_name: address_info?.state_info.name,
        delivery_location_id: address_info?.location_info.location_id,
        delivery_location_name: address_info?.location_info.location_name,
        delivery_type: stpInfo?.delivery_info?.delivery_type,
        receiver_name: stpInfo?.receiver_info?.name,
        receiver_mobile: stpInfo?.receiver_info?.phone_number,
        incoterms: 2
      }
    };
  });

  return {
    orderBookingId: data.order_details.id,
    shipToPartyCarts
  };
};
